import React from 'react';
import { Box, Chip, IconButton, Typography } from '@mui/material';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ClearIcon from '@mui/icons-material/Clear';
import SectionCard from '../inventory/components/SectionCard';
import ChargeServiceAutocomplete from './ChargeServiceAutocomplete';
import { OT_SURGERY_CLASSIFICATION } from './otChargeApi';
import { OT_SECTION_SX, OT_SELECTED_GRADIENT } from './otTheme';
import { IPD_COLORS, INV_RADIUS } from '../inventory/theme';

function SelectedServiceCard({ service, onClear }) {
  const chips = [service.category, service.serviceType, service.service_code || service.code].filter(Boolean);

  return (
    <Box
      sx={{
        mt: 2,
        p: 2,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.75,
        borderRadius: `${INV_RADIUS.card}px`,
        border: `1px solid ${IPD_COLORS.selectedBorder}`,
        background: OT_SELECTED_GRADIENT,
        boxShadow: IPD_COLORS.shadow.selected,
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: `${INV_RADIUS.control}px`,
          background: OT_SELECTED_GRADIENT,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          color: IPD_COLORS.chipInfoText,
          boxShadow: IPD_COLORS.shadow.card,
          border: `1px solid ${IPD_COLORS.border}`,
        }}
      >
        <MedicalServicesOutlinedIcon fontSize="small" />
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.35 }}>
          <CheckCircleIcon sx={{ fontSize: 16, color: IPD_COLORS.success.text, flexShrink: 0 }} />
          <Typography sx={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', color: IPD_COLORS.chipInfoText }}>
            Selected service
          </Typography>
        </Box>
        <Typography sx={{ fontWeight: 700, fontSize: 16, color: IPD_COLORS.textPrimary, lineHeight: 1.35 }}>
          {service.name}
        </Typography>
        {chips.length > 0 && (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, mt: 1 }}>
            {chips.map((chip, i) => (
              <Chip
                key={`${chip}-${i}`}
                label={chip}
                size="small"
                sx={{
                  height: 22,
                  fontSize: 11.5,
                  fontWeight: 600,
                  backgroundColor: IPD_COLORS.white,
                  color: IPD_COLORS.textPrimary,
                  border: `1px solid ${IPD_COLORS.border}`,
                }}
              />
            ))}
          </Box>
        )}
      </Box>

      <IconButton
        size="small"
        aria-label="Clear service"
        onClick={onClear}
        sx={{ color: IPD_COLORS.textSecondary, mt: -0.25 }}
      >
        <ClearIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}

export default function ServiceSelectionSection({ service, onServiceChange }) {
  return (
    <SectionCard title="Service Selection" sx={OT_SECTION_SX}>
      <ChargeServiceAutocomplete
        label="Service"
        placeholder="Search surgical procedures…"
        value={service}
        onChange={onServiceChange}
        classificationName={OT_SURGERY_CLASSIFICATION}
      />
      {service && (
        <SelectedServiceCard service={service} onClear={() => onServiceChange(null)} />
      )}
    </SectionCard>
  );
}
